import { z } from 'zod';

/** What a request rejected by validation gets back (HTTP 400). */
export const ValidationErrorResponse = z.object({
  error: z.string(),
  issues: z.array(z.object({ path: z.string(), message: z.string() })),
});
export type ValidationErrorResponse = z.infer<typeof ValidationErrorResponse>;
